import React from 'react'
import { makeStyles } from '@material-ui/styles'

import { StyledAppBar } from './style'

export const AppBar = React.forwardRef((props, ref) => (
    <StyledAppBar
        color='transparent'
        position='relative'
        {...props}
        ref={ref}
    />
))

const useStyle = makeStyles(theme => ({
    toolbarMargin: {
        ...theme.mixins.toolbar,
    },
}))

export const ToolbarMargin = () => {
    const classes = useStyle()
    return <div className={classes.toolbarMargin}></div>
}
